// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFlagOutlinedSvg from "@fishx/icons-svg/es/asn/PFlagOutlined";
import FishxIcon from '../components/FishxIcon';

var PFlagOutlined = function PFlagOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFlagOutlinedSvg
  }));
};

PFlagOutlined.displayName = 'PFlagOutlined';
export default React.forwardRef(PFlagOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFlagOutlined.js
// module id = 3413
// module chunks = 0